import palette from '../theme/palette';

const styleOverrides = {
  root: {
    opacity: 1,
    minHeight: '0',
    maxWidth: 'none',
    justifyContent: 'start',
    textAlign: 'start',
    '&.Mui-selected, :hover': {
      color: palette.primary.main,
    },
  },
};

export default styleOverrides;
